import React, { useState } from "react";
import Header from "./Header";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import { formatDecimal } from "../../../hooks/Method";

const TrialBalance = () => {
  const [reports, setReports] = useState([]);

  const totalDebit = reports.reduce((sum, r) => sum + (r.debit || 0), 0);
  const totalCredit = reports.reduce((sum, r) => sum + (r.credit || 0), 0);

  return (
    <Box className="flex flex-col gap-4">
      <Header setValues={setReports} />

      {reports && reports.length > 0 ? (
        <Paper
          sx={{
            p: 2,
            borderRadius: 3,
            backgroundColor: "#ffffff",
          }}
        >
          <TableContainer>
            <Table
              size="small"
              sx={{ minWidth: 700 }}
              aria-label="Trial Balance Table"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f9fafb" }}>
                  <TableCell sx={{ fontWeight: 600, fontSize: "15px" }}>
                    Account
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ fontWeight: 600, fontSize: "15px" }}
                  >
                    Debit
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ fontWeight: 600, fontSize: "15px" }}
                  >
                    Credit
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {reports.map((r, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:nth-of-type(odd)": {
                        backgroundColor: "#fcfcfc",
                      },
                    }}
                  >
                    <TableCell>{r.account}</TableCell>
                    <TableCell align="right">
                      {r.debit ? formatDecimal(r.debit, true) : "-"}
                    </TableCell>
                    <TableCell align="right">
                      {r.credit ? formatDecimal(r.credit, true) : "-"}
                    </TableCell>
                  </TableRow>
                ))}

                {/* Total Row */}
                <TableRow sx={{ backgroundColor: "#f0f4f8" }}>
                  <TableCell sx={{ fontWeight: 600 }}>Total</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600 }}>
                    {formatDecimal(totalDebit, true)}
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600 }}>
                    {formatDecimal(totalCredit, true)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      ) : (
        <Paper elevation={1} sx={{ p: 3, textAlign: "center", color: "#888" }}>
          <Typography variant="subtitle1">
            No trial balance data available
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default TrialBalance;
